export function getXeroInvoiceUrl(externalId: string): string {
  return `https://go.xero.com/AccountsReceivable/View.aspx?invoiceID=${externalId}`;
}
